import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../../models/document.model';
import {AlertController, ModalController} from '@ionic/angular';
import {PersistDocumentService} from '../../../services/persist-document.service';
import {GeneralService} from '../../../services/general.service';

@Component({
    selector: 'app-sign-document-health-care',
    templateUrl: './sign-document-health-care.page.html',
    styleUrls: ['./sign-document-health-care.page.scss'],
})
export class SignDocumentHealthCarePage implements OnInit {

    @Input() document: DocumentModel;
    documentTemp: DocumentModel;
    title: string;

    constructor(private modalController: ModalController,
                private alertController: AlertController,
                private persistDocService: PersistDocumentService,
                private generalServices: GeneralService) {
    }

    ngOnInit() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
        this.setTitle();
    }

    saveSignedDocument() {
        this.document = JSON.parse(JSON.stringify(this.documentTemp));
        this.persistDocService.persistDocument(this.document);
        this.modalController.dismiss(this.document);
        this.generalServices.createToast(this.title + ' Saved!');
    }

    cancelSignedDocument() {
        if (this.documentTemp !== this.document) {
            this.confirmCancel();
        } else {
            this.modalController.dismiss();
        }
    }

    async confirmCancel() {
        const alert = await this.alertController.create({
            message: 'Do you want to cancel the Document?',
            backdropDismiss: false,
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }, {
                    text: 'Yes',
                    handler: () => {
                        this.modalController.dismiss();
                    }
                }
            ]
        });
        await alert.present();
    }

    setTitle() {
        if (this.documentTemp.originalDocumentType === 1) {
            this.title = 'Delivery';
        } else if (this.documentTemp.originalDocumentType === 7) {
            this.title = 'Collection';
        } else if (this.documentTemp.originalDocumentType === 2) {
            this.title = 'Return';
        } else {
            this.title = 'Sign Document';
        }
    }

}
